import {getField, updateField} from "vuex-map-fields";
import router from './../../router.js'

// import {testUser} from "../../js/testUser";

const nullUser = {
  first_name: null,
  last_name: null,
  email: null,
  country: null,
  state: {text:null, value: null},
  is_admin: null,
  organizationName: null,
  apiKey: null,
  secret_key: 'defaultSecret'
  };

const state = {
  user: nullUser,
  // secret_key: "88cf972d8232c27d3245818098c9b6a9",
  // token: "123412",
};

const getters = {
  isLoggedIn(context){
    return context.user.email !== null
  },
  getField,
};

const actions = {
  createUser(context, userData){
    const userDataDefault = {
      email: 'ben@trisightengineering.com',
      first_name: 'ben',
      last_name: 'ciavola',
      country: 'USA',
      state: 'MI',
      title: 'dev',
      is_admin: true,
      password1: 'password',
      password2: 'password',
      organizationName: 'trisight'
    };

    return context.dispatch('postToServer', {
      action: 'createUser',
      user: userData
    }, {root: true})
  },

  login(context, userCredentials){
    if (userCredentials === undefined){
      userCredentials = {email: 'ben@trisightengineering.com', password: 'password'}
    }
    return context.dispatch('postToServer',
      {
        action: 'login',
        email: userCredentials.email,
        password: userCredentials.password
      }, {root: true}
    ).then(result => {
      if (result.status === 'success'){
        // Successful login
        const payload = JSON.parse(result.payload);
        const newUser = payload.user;
        // Save the user
        context.commit('setLoggedInUser', newUser);
        // Collect the other user data that is required for phase-1 navigation
        context.dispatch('rx/getFolders', null, {root:true});
        context.dispatch('rx/getAvailableProjects', null, {root:true})
      }
      return result
    });
  },
  logout(context){
    context.commit('setLoggedOut');
    context.commit('rx/setCurrentProject', null, {root: true});
    context.commit('rx/setFolders', {
      name: "Main Folder",
      id: 0,
      isOpen: true,
      children: [],
      parent: null,
    }, {root: true});
  },
  updateUser(context){
    console.log("updating user", context.state.user);
    return context.dispatch('postToServer', {
      action: 'updateUser',
      user: context.state.user,
    }, {root: true})
  }
};

const mutations = {
  setLoggedInUser (state, userData){
    console.log('Received logged-inuser data:', userData);
    state.user = userData;
  },

  setLoggedOut (state){
    state.user = nullUser;
    router.push('/')
  },
  updateField
};

export default {
  moduleName: 'account',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}